import FormAudit from "../../components/forms/FormAudit/FormAudit";
import Breadcrumbs from "../../components/layout/BreadCrumbs";
import PageLayout from "../../components/layout/PageLayout/PageLayout";
import {
  useFetchAuditTypesQuery,
  useFetchRolesQuery,
  useFetchSitesQuery,
  useFetchUsersForFieldQuery,
} from "../../features/api/apiSlice";

const PageAuditCreate = () => {
  const { data: sitesData } = useFetchSitesQuery();
  const { data: auditTypesData } = useFetchAuditTypesQuery();
  const { data: usersData } = useFetchUsersForFieldQuery("");
  const { data: rolesData } = useFetchRolesQuery();

  return (
    <PageLayout>
      <Breadcrumbs pageName="newAudit" />
      <FormAudit
        sites={sitesData?.results}
        auditTypes={auditTypesData?.results}
        users={usersData}
        roles={rolesData?.results}
      />
    </PageLayout>
  );
};

export default PageAuditCreate;
